export default __webpack_public_path__ + "static/media/stamp7.e04d14a5.png";